import { api, hrRoutes } from "../../../";
import { ApiConfig } from "../../../ApiConfig";
const baseURL = ApiConfig.baseApi;
// ----------------------------------------------------------------
// Define employees salaries services
// ----------------------------------------------------------------

const services = {

  // ----------------------------------------------------------------
  // Add bonus for employees
  // ----------------------------------------------------------------

  addBonus: (employees, bonus, date, to, fixed, bonusName, payType) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.salary.bonus;
    const params = {
      employees: employees,
      rate: bonus,
      end: to,
      start: date,
      rateType: fixed,
      name: bonusName,
    };
    
    // Add payType only when rateType is "Percentage"
    if (fixed === "Percentage" && payType) {
      params.payType = payType;
    }
    
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },
  // ----------------------------------------------------------------
  // Bonus date
  // ----------------------------------------------------------------

  BonusDate: (date, to) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.salary.bonusdate;
    const params = {
      end: to,
      start: date,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },
  // ----------------------------------------------------------------
  // Get payslip as PDF
  // ----------------------------------------------------------------

  payslipPDF: (payslipId) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.salary.payslipPDF + payslipId;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, {}, headers);
  },

  // ----------------------------------------------------------------
  // show payslip PDF
  // ----------------------------------------------------------------

  showPdf: async (id) => {
    const token = localStorage.getItem("accessToken");
    const params = new URLSearchParams();

    const url = `${baseURL}${hrRoutes.salary.showPayslipPdfL}${id}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.get(url, params, headers);
  },

};
// Export the services
export default services;
